var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContactInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1246E5",
    d: "M24 2H9a3 3 0 0 0-3 3v4h2a1 1 0 0 1 0 2H6v4h2a1 1 0 0 1 0 2H6v4h2a1 1 0 0 1 0 2H6v4a3 3 0 0 0 3 3h15a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3zm-2 19a1 1 0 0 1-1-1 4 4 0 0 0-8 0 1 1 0 0 1-2 0 6 6 0 0 1 3.9-5.61 4 4 0 1 1 4.2 0A6 6 0 0 1 23 20a1 1 0 0 1-1 1z",
    opacity: 1,
    "data-original": "#2896d3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#30938C",
    d: "M19 11a2 2 0 1 1-2-2 2 2 0 0 1 2 2zM9 10a1 1 0 0 0-1-1H6a1 1 0 0 0 0 2h2a1 1 0 0 0 1-1zm-1 7H6a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2zm0 6H6a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2z",
    opacity: 1,
    "data-original": "#00293b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactInfo);
export default __webpack_public_path__ + "static/media/contact_info.b59d215a34606e7d79c6e972ab29c52b.svg";
export { ForwardRef as ReactComponent };